"use client"
import styled from "styled-components"
import Register from "../components/Register"

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 160px);
`

const RegisterPage = () => {
  return (
    <PageContainer>
      <Register />
    </PageContainer>
  )
}

export default RegisterPage

